import { Dialog } from "@mui/material";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import Skeleton from "react-loading-skeleton";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SweetAlert2 from "react-sweetalert2";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import { useAuth } from "../../auth/components/AuthInit";
import Pagination from "../../common/Pagination";
import { CreateMemberDialog } from "../../memberlist/components/CreateMemberDialog";
import { MemberList } from "../../memberlist/components/MemberList";
import * as actions from "../redux/AgentAction";
import { AgentDetails } from "./AgentDetails";
import { AgentGameList } from "./AgentGameList";
import "./agentList.css";
import { AgentLotteryList } from "./AgentLotteryList";
import { CreateAgentDialog } from "./CreateAgentDialog";
import { LinkTelegramDialog } from "./linkTelegram/LinkTelegramDialog";
import { ShareDialog } from "./ShareModal";
import { TopupAndWithdrawDialog } from "./TopupAndWithdrawDialog";

export const AgentModalEnum = {
  Detail: 1,
  TopupWithdraw: 2,
  GameList: 3,
  Lottery: 4,
};

export const AgentList = () => {
  const intl = useIntl();
  const [swalProps, setSwalProps] = useState({});
  const [selAgentId, setSelAgentId] = useState(null);
  const [selMemberId, setSelMemberId] = useState(null);
  const [selUsername, setSelUsername] = useState(null);
  const [selNickname, setSelNickname] = useState(null);
  const [selBalance, setSelBalance] = useState(null);
  const [selQuota, setSelQuota] = useState(null);
  const [topUpLine, setTopUpLine] = useState(null);
  const [currentAgent, setCurrentAgent] = useState(null);
  const [currentAgentId, setCurrentAgentId] = useState(null);
  const [backToPagination, setBackToPagination] = useState(null);
  const [modalOpen, setModalOpen] = useState();
  const [currentMemberPage, setCurrentMemberPage] = useState(0);
  const [currentAgentPage, setCurrentAgentPage] = useState(0);
  const [agentDetailsVisible, setAgentDetailsVisible] = useState(false);
  const [memberDetailsVisible, setMemberDetailsVisible] = useState(false);
  // const [agentFeeChargeVisible, setAgentFeeChargeVisible] = useState(false);
  const [agentLotteryVisible, setAgentLotteryVisible] = useState(false);
  const [pathFromSearch, setPathFromSearch] = useState("");
  const [searchUsername, setSearchUsername] = useState("");
  const [memberSettingPermission, setMemberSettingPermission] = useState("");
  const [agentSettingPermission, setAgentSettingPermission] = useState("");
  const [creditControlPermission, setCreditControlPermission] = useState("");
  const [memberBalancePermission, setMemberBalancePermission] = useState("");
  const [fromSide, setFromSide] = useState("");
  const dispatch = useDispatch();
  const { auth } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const agentState = useSelector(({ agent }) => agent, shallowEqual);
  const isMM6MM = process.env.REACT_APP_PROJECT_ID === "mm6mm";

  useEffect(() => {
    const initialAgentId =
      location.state?.agentId || (auth.selagentid ?? auth.agentid);
    const returnAgentId = location.state?.returnAgentId;
    const returnUsername = location.state?.returnUsername;
    const initialUsername = location.state?.username || auth.username;
    const backToPagination = location.state?.backToPagination || 0;
    const backToAgentPagination = location.state?.backToAgentPagination || 0;
    const savedScrollPosition = location.state?.scrollPosition || 0;
    const pathFromSearch = location.state?.searchName;
    const searchUsername = location.state?.searchUsername;

    setPathFromSearch(pathFromSearch);
    setBackToPagination(backToPagination);
    setSearchUsername(searchUsername);
    if (backToPagination != null && backToPagination != "") {
      setCurrentMemberPage(backToPagination);
    }
    if (backToAgentPagination != null && backToAgentPagination != "") {
      setCurrentAgentPage(backToAgentPagination);
    }

    if (savedScrollPosition) {
      window.scrollTo(0, savedScrollPosition);
    }
    if (
      returnAgentId &&
      returnAgentId !== "undefined" &&
      returnAgentId !== ""
    ) {
      setCurrentAgent(returnUsername);
      setCurrentAgentId(returnAgentId);
      const queryParams = {
        action: "agentmemberlist",
        selagentid: returnAgentId,
        agentpagenum: backToAgentPagination,
        memberpagenum: backToPagination,
      };
      dispatch(actions.callAgentList(queryParams)).then((resp) => {
        resp = resp.data;
        setTopUpLine(resp.agentUplineLists);
      });
    } else {
      setCurrentAgentId(initialAgentId);
      setCurrentAgent(initialUsername);
      const queryParams = {
        action: "agentmemberlist",
        selagentid: initialAgentId,
        agentpagenum: backToAgentPagination,
        memberpagenum: backToPagination,
      };
      dispatch(actions.callAgentList(queryParams)).then((resp) => {
        resp = resp.data;
        setTopUpLine(resp.agentUplineLists);
      });
    }
  }, [
    location.state,
    auth.agentid,
    auth.selagentid,
    auth.username,
    dispatch,
    backToPagination,
  ]);

  const handleClick = (agentId, username) => {
    setCurrentAgent(username);
    setCurrentAgentId(agentId);
    const queryParams = {
      action: "agentmemberlist",
      selagentid: agentId,
      agentpagenum: "0",
      memberpagenum: "0",
    };

    dispatch(actions.callAgentList(queryParams))
      .then((resp) => {
        resp = resp.data;
        setTopUpLine(resp.agentUplineLists);
      })
      .catch((error) => {
        console.error("Error fetching agent list:", error);
      });
  };
  const handleVipChange = (e, memberId) => {
    const newVip = e.target.value;
    const queryParams = {
      action: "updatemembervip",
      memberid: memberId,
      viplevel: newVip,
    };
    dispatch(actions.updateMemberVip(queryParams)).then((resp) => {
      resp = resp.data;
      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        handlePageClick(0)
        setSwalProps({
          show: true,
          icon: "success",
          title: intl.formatMessage({ id: "success" }),
          text: intl.formatMessage({ id: "updateMemberVipSuccess" }),
        });
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    }).catch((error) => {
      setSwalProps({
        show: true,
        icon: "error",
        title: intl.formatMessage({ id: "error" }),
        text: error.message,
      });
    });
  };
  const handlePageClick = (pageNumber) => {
    setCurrentAgentPage(pageNumber);
    const queryParams = {
      action: "agentmemberlist",
      selagentid: currentAgentId,
      agentpagenum: pageNumber,
      memberpagenum: currentMemberPage,
    };
    dispatch(actions.callAgentList(queryParams)).then((resp) => {
      resp = resp.data;
      setTopUpLine(resp.agentUplineLists);
    });
  };
  const handlePageClick1 = (pageNumber) => {
    setCurrentMemberPage(pageNumber);
    const queryParams = {
      action: "agentmemberlist",
      selagentid: currentAgentId,
      agentpagenum: currentAgentPage,
      memberpagenum: pageNumber,
    };
    dispatch(actions.callAgentList(queryParams)).then((resp) => {
      resp = resp.data;
      setTopUpLine(resp.agentUplineLists);
    });
  };

  const handleNavigate = (path, state) => {
    const scrollPosition = window.scrollY;
    navigate(path, {
      state: {
        ...state,
        scrollPosition,
      },
    });
  };
  useEffect(() => {
    const storedUserPermission = JSON.parse(
      localStorage.getItem("permissions")
    );
    if (storedUserPermission) {
      storedUserPermission.forEach((permission) => {
        switch (permission.permissioncode) {
          case "membersetting":
            setMemberSettingPermission(permission.allow);
            break;
          case "agentsetting":
            setAgentSettingPermission(permission.allow);
            break;
          case "creditcontrol":
            setCreditControlPermission(permission.allow);
            break;
          case "memberbalancecontrol":
            setMemberBalancePermission(permission.allow);
            break;
          default:
            break;
        }
      });
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
  };
  const handlNew = () => {
    // window.open(redirectAgent);
    setOpen(false);
  };

  return (
    <div>
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      <ShareDialog
        selAgentId={selAgentId}
        selMemberId={selMemberId}
        fromSide={fromSide}
      />
      <CreateAgentDialog
        setSwalProps={setSwalProps}
        pageParams={{
          agentpagenum: currentAgentPage,
          memberpagenum: currentMemberPage,
        }}
      />
      <CreateMemberDialog
        setSwalProps={setSwalProps}
        isAgent={true}
        pageParams={{
          agentpagenum: currentAgentPage,
          memberpagenum: currentMemberPage,
        }}
      />
      <AgentGameList
        selAgentId={
          modalOpen === AgentModalEnum.GameList ? selAgentId : undefined
        }
        selUsername={selUsername}
      />
      <AgentDetails
        selAgentId={
          modalOpen === AgentModalEnum.Detail ? selAgentId : undefined
        }
        isAgentDetailsVisible={agentDetailsVisible}
        currentAgentId={currentAgentId}
        currentAgentPage={currentAgentPage}
        agentSettingPermission={agentSettingPermission}
        onClose={() => setAgentDetailsVisible(false)}
      />
      <MemberList
        selMemberId={selMemberId}
        currentAgentId={currentAgentId}
        currentMemberPage={currentMemberPage}
        isMemberDetailsVisible={memberDetailsVisible}
        memberSettingPermission={memberSettingPermission}
        onClose={() => setMemberDetailsVisible(false)}
        isAgent={true}
      />
      <TopupAndWithdrawDialog
        setSwalProps={setSwalProps}
        currentAgentPage={currentAgentPage}
        currentMemberPage={currentMemberPage}
        currentAgentId={currentAgentId}
        selAgentId={
          modalOpen === AgentModalEnum.TopupWithdraw ? selAgentId : undefined
        }
        selUsername={selUsername}
        selNickname={selNickname}
        selBalance={selBalance}
        selQuota={selQuota}
      />
      <AgentLotteryList
        setSwalProps={setSwalProps}
        currentAgentId={currentAgentId}
        selAgentId={
          modalOpen === AgentModalEnum.Lottery ? selAgentId : undefined
        }
        selUsername={selUsername}
        pathFromSearch={pathFromSearch}
        searchUsername={searchUsername}
        isAgentLotteryVisible={agentLotteryVisible}
        onClose={() => setAgentLotteryVisible(false)}
      />
      <LinkTelegramDialog selMemberId={selMemberId} />
      <div className="d-flex align-items-center">
        {pathFromSearch == "yes" && (
          <h2>
            <i
              className="bi bi-chevron-left"
              onClick={() => {
                navigate("/searchByUsername", {
                  state: {
                    searchUsername: searchUsername,
                  },
                });
              }}
            ></i>
          </h2>
        )}
        <h2>{intl.formatMessage({ id: "accountList" })}</h2>
      </div>

      {agentState && agentState.agentLists && (
        <div>
          {intl.formatMessage({ id: "telegramInviteLink" }) + " : "}
          <a
            href={agentState.agentLists.telegraminvitelink}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline", color: "#0080FF" }} // Color blue for link styling
          >
            {agentState.agentLists.telegraminvitelink}
          </a>
        </div>
      )}
      <div
        className="buttonCss"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <div>
          <nav>
            <ol className="breadcrumb">
              {topUpLine && topUpLine.length > 0 ? (
                <>
                  <li>
                    {topUpLine
                      .slice()
                      .reverse()
                      .map((agent, index) => (
                        <>
                          <span
                            key={index}
                            onClick={() =>
                              handleClick(agent.agentid, agent.username)
                            }
                          >
                            {index > 0 && " / "}
                            <span style={{ textDecoration: "underline" }}>
                              {agent.username}
                            </span>
                          </span>
                        </>
                      ))}
                  </li>
                </>
              ) : (
                <li>
                  <span
                    onClick={() =>
                      handleClick(
                        auth.selagentid ?? auth.agentid,
                        auth.username
                      )
                    }
                  >
                    {auth.username}
                  </span>
                </li>
              )}
              {topUpLine && topUpLine.length > 0 && (
                <li>
                  <span className="breadcrumb-separator">/</span>
                  <span>{currentAgent}</span>
                </li>
              )}
            </ol>
          </nav>
        </div>

        {agentSettingPermission === "true" && (
          <>
            <button
              className="btn btn-primary buttonAdd"
              data-bs-toggle="modal"
              data-bs-target={`#addAgentModal`}
            >
              {intl.formatMessage({ id: "addAgent" })}
            </button>
          </>
        )}
      </div>
      <div
        className="agent-div"
        style={{
          margin: "10px auto",
        }}
      >
        <div className="agent-container" style={{ overflowX: "auto" }}>
          <table className="agent-table">
            <thead className="agent-header">
              <tr className="agent-row">
                <th className="agent-cell hide-on-mobile col-1">
                  {intl.formatMessage({ id: "no" })}
                </th>
                <th className="agent-cell col-2 fixed-column">
                  {intl.formatMessage({ id: "username" })}
                </th>
                <th className="agent-cell col-2">
                  {intl.formatMessage({ id: "nickname" })}
                </th>
                <th className="agent-cell agent-col text-end">
                  {intl.formatMessage({ id: "balance" })}
                </th>
                <th className="agent-cell col-2">
                  {intl.formatMessage({ id: "status" })}
                </th>
                <th className="agent-cell agent-col text-center">
                  {intl.formatMessage({ id: "share" })}
                </th>
                <th className="agent-cell col-2">
                  {intl.formatMessage({ id: "action" })}
                </th>
              </tr>
            </thead>
            <tbody className="agent-body">
              {agentState.agentLists?.agentList?.agentLists ? (
                agentState.agentLists.agentList.agentLists.length > 0 ? (
                  agentState.agentLists.agentList.agentLists.map(
                    (agent, index) => (
                      <tr key={index} className="agent-row">
                        <td className="agent-cell hide-on-mobile col-1">
                          {index + 1}
                        </td>
                        <td className="agent-cell col-2 fixed-column">
                          <button
                            className="buttonName"
                            onClick={() =>
                              handleClick(agent.agentid, agent.username)
                            }
                          >
                            {agent.username}
                          </button>
                        </td>
                        <td className="agent-cell col-2">{agent.nickname}</td>
                        <td className="agent-cell agent-col text-end">
                          {agent.balance}
                        </td>
                        <td className="agent-cell col-2">{agent.status}</td>

                        <td className="agent-cell agent-col text-center">
                          {agent.ispasswordnew === "true" && (
                            <i
                              className="bi bi-share"
                              data-bs-toggle="modal"
                              data-bs-target={`#ShareModal`}
                              onClick={() => {
                                setSelAgentId(agent.agentid);
                                setFromSide("agent");
                              }}
                            ></i>
                          )}
                        </td>

                        <td className="agent-cell col-2 d-flex">
                          <button
                            className="btn btn-primary me-1"
                            style={{
                              backgroundColor: "#00FFFF",
                              borderColor: "#00FFFF",
                              color: "black",
                            }}
                            onClick={() => {
                              setModalOpen(AgentModalEnum.Detail);
                              setSelAgentId(agent.agentid);
                              setAgentDetailsVisible(true);
                            }}
                          >
                            <i className="bi bi-exclamation-circle" />
                          </button>
                          {creditControlPermission === "true" && (
                            <>
                              <button
                                className="btn btn-primary me-1"
                                style={{
                                  backgroundColor: "#00FF00",
                                  borderColor: "#00FF00",
                                  color: "black",
                                }}
                                data-bs-toggle="modal"
                                data-bs-target="#TopupAndWithdrawModal"
                                onClick={() => {
                                  setModalOpen(AgentModalEnum.TopupWithdraw);
                                  setSelAgentId(agent.agentid);
                                  setSelUsername(agent.username);
                                  setSelNickname(agent.nickname);
                                  setSelBalance(agent.balance);
                                  setSelQuota(agent.acctquota);
                                }}
                              >
                                <i className="bi bi-wallet2" />
                              </button>
                              <button
                                className="btn btn-primary me-1"
                                style={{
                                  backgroundColor: "#FFFF00",
                                  borderColor: "#FFFF00",
                                  color: "black",
                                }}
                                data-bs-toggle="modal"
                                data-bs-target={`#GameListModal`}
                                onClick={() => {
                                  setModalOpen(AgentModalEnum.GameList);
                                  setSelAgentId(agent.agentid);
                                  setSelUsername(agent.username);
                                }}
                              >
                                <i className="bi bi-list-ul" />
                              </button>
                            </>
                          )}
                          {agentSettingPermission === "true" && !isMM6MM && (
                            <>
                              <button
                                className="btn btn-primary"
                                style={{
                                  backgroundColor: "#0080FF",
                                  borderColor: "#0080FF",
                                  color: "black",
                                }}
                                onClick={() => {
                                  setModalOpen(AgentModalEnum.Lottery);
                                  setSelAgentId(agent.agentid);
                                  setSelUsername(agent.username);
                                  setAgentLotteryVisible(true);
                                }}
                              >
                                <i className="bi bi-4-circle" />
                              </button>
                            </>
                          )}
                          {/* <button
                            className="btn btn-primary"
                            style={{
                              backgroundColor: "#0080FF",
                              borderColor: "#0080FF",
                              color: "black",
                            }}
                            onClick={() => {
                              setSelUsername(agent.username);
                              setSelAgentId(agent.agentid);
                              setAgentFeeChargeVisible(true);
                            }}
                          >
                            <i className="bi bi-diagram-2" />
                          </button> */}
                        </td>
                      </tr>
                    )
                  )
                ) : (
                  <tr className="oRecordDiv">
                    <td colSpan="5">
                      <div className="no-record-wrapper">
                        <i className="bi bi-search fs-1 mb-3" />
                        <div className="text-font2">
                          {intl.formatMessage({ id: "noRecordFound" })}
                        </div>
                      </div>
                    </td>
                  </tr>
                )
              ) : (
                <tr>
                  <td colSpan="5">
                    <Skeleton height="600px" className="w-100" />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          totalPages={parseInt(
            agentState.agentLists?.agentList?.totalpage ?? "0"
          )}
          currentPage={currentAgentPage}
          onPageChange={(pageNumber) => {
            handlePageClick(pageNumber);
          }}
        />
        <div
          className="buttonCss"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          {intl.formatMessage({ id: "memberList" })}
          {memberSettingPermission === "true" && (
            <>
              <button
                className="btn btn-primary buttonAdd"
                data-bs-toggle="modal"
                data-bs-target={`#addMemberModal`}
              >
                {intl.formatMessage({ id: "addMember" })}
              </button>
            </>
          )}
        </div>
        <div className="agent-container" style={{ overflowX: "auto" }}>
          <table className="agent-table" style={{ minWidth: "400px" }}>
            <thead className="agent-header">
              <tr>
                <th className="agent-cell hide-on-mobile">
                  {intl.formatMessage({ id: "no" })}
                </th>
                <th className="agent-cell fixed-column">
                  {intl.formatMessage({ id: "username" })}
                </th>
                <th className="agent-cell">
                  {intl.formatMessage({ id: "nickname" })}
                </th>
                {agentState.agentLists?.telnoshow === "true" && !isMM6MM && (
                  <th className="agent-cell">
                    {intl.formatMessage({ id: "phoneNo" })}
                  </th>
                )}
                {isMM6MM && (
                  <th className="agent-cell">
                    {intl.formatMessage({ id: "status" })}
                  </th>
                )}
                <th className="agent-cell agent-col">
                  {intl.formatMessage({ id: "vip" })}
                </th>
                <th className="agent-cell agent-col text-center">
                  {intl.formatMessage({ id: "share" })}
                </th>
                <th className="agent-cell" style={{ width: "1px" }}>
                  {intl.formatMessage({ id: "action" })}
                </th>
              </tr>
            </thead>
            <tbody className="agent-body">
              {agentState.agentLists &&
                agentState.agentLists.memberList &&
                agentState.agentLists.memberList.memberLists ? (
                agentState.agentLists.memberList.memberLists.length > 0 ? (
                  agentState.agentLists.memberList.memberLists.map(
                    (member, index) => (
                      <tr
                        key={index}
                        style={{
                          borderBottom: "1px solid rgb(175, 164, 164, 0.4)",
                        }}
                      >
                        <td className="agent-cell hide-on-mobile">
                          {index + 1}
                        </td>
                        <td className="agent-cell fixed-column">
                          {member.username}
                        </td>
                        <td className="agent-cell">{member.nickname}</td>
                        {agentState.agentLists?.telnoshow === "true" && !isMM6MM && (
                          <td className="agent-cell">{member.telno}</td>
                        )}
                        {isMM6MM && (
                          <td className="agent-cell">{member.status}</td>
                        )}
                        <td className="agent-cell">
                          <select
                            className="dropdown"
                            onChange={(e) => handleVipChange(e, member.memberid)}
                            value={member.vip}
                          >
                            {agentState.agentLists?.memberVipLevelLists?.map(
                              (vip) => (
                                <option key={vip.viplevel} value={vip.viplevel}>
                                  Level {vip.viplevel}
                                </option>
                              )
                            )}
                          </select>
                        </td>
                        <td className="agent-cell agent-col text-center">
                          {member.ispasswordnew === "true" && (
                            <i
                              className="bi bi-share"
                              data-bs-toggle="modal"
                              data-bs-target={`#ShareModal`}
                              onClick={() => {
                                setSelMemberId(member.memberid);
                                setFromSide("member");
                              }}
                            ></i>
                          )}
                        </td>
                        <td className="agent-cell d-flex justify-content-end">
                          <button
                            className="btn btn-primary me-1"
                            style={{
                              backgroundColor: "#00FFFF",
                              borderColor: "#00FFFF",
                              color: "black",
                            }}
                            onClick={() => {
                              setSelMemberId(member.memberid);
                              setMemberDetailsVisible(true);
                            }}
                          >
                            <i className="bi bi-exclamation-circle" />
                          </button>
                          <button
                            className="btn btn-primary me-1"
                            style={{
                              backgroundColor: "#00FF00",
                              borderColor: "#00FF00",
                              color: "black",
                            }}
                            onClick={() =>
                              handleNavigate(
                                `/memberList/gameList/${member.memberid}`,
                                {
                                  state: {
                                    userName: member.username,
                                    pagination: currentMemberPage,
                                    memberBalancePermission:
                                      memberBalancePermission,
                                    currentAgentId: currentAgentId,
                                    currentUsername: currentAgent,
                                  },
                                }
                              )
                            }
                          >
                            <i className="bi bi-controller" />
                          </button>
                          <button
                            className="btn btn-primary me-1"
                            style={{
                              backgroundColor: "#FFFF00",
                              borderColor: "#FFFF00",
                              color: "black",
                            }}
                            onClick={() => {
                              handleNavigate(
                                `/memberList/memberReport/${member.memberid}`,
                                {
                                  state: {
                                    currentAgentId: currentAgentId,
                                    userName: member.username,
                                    pagination: currentMemberPage,
                                    currentUsername: currentAgent,
                                  },
                                }
                              );
                            }}
                          >
                            <i className="bi bi-clipboard2-data" />
                          </button>
                          {!isMM6MM && (
                            <button
                              className="btn btn-primary me-1"
                              style={{
                                backgroundColor: "rgb(0, 128, 255)",
                                borderColor: "rgb(0, 128, 255)",
                                color: "black",
                              }}
                              data-bs-toggle="modal"
                              data-bs-target={`#LinkTelegramModal`}
                              onClick={() => {
                                setSelMemberId(member.memberid);
                              }}
                            >
                              <i className="bi bi-link-45deg" />
                            </button>
                          )}
                        </td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td colSpan="5">
                      <div className="no-record-wrapper">
                        <i className="bi bi-search fs-1 mb-3" />
                        <div className="text-font2">
                          {intl.formatMessage({ id: "noRecordFound" })}
                        </div>
                      </div>
                    </td>
                  </tr>
                )
              ) : (
                <tr>
                  <td colSpan="5">
                    <Skeleton height="600px" className="w-100" />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          totalPages={parseInt(
            agentState.agentLists?.memberList?.totalpage ?? "0"
          )}
          currentPage={currentMemberPage}
          onPageChange={(pageNumber) => {
            handlePageClick1(pageNumber);
          }}
        />
      </div>
      <Dialog open={open} onClose={handleClose}>
        <div
          className="text-font3"
          style={{
            padding: "20px",
            backgroundColor: "#1c1e23",
            color: "white",
          }}
        >
          <p> {intl.formatMessage({ id: "openNewRedirectTab" })}</p>
          <div
            style={{ color: "#f5be09", textAlign: "end" }}
            onClick={handlNew}
          >
            {intl.formatMessage({ id: "confirm" })}
          </div>
        </div>
      </Dialog>
    </div>
  );
};
